import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Layout primitive. Renders a `div` with `display: flex` and the requested
 * direction/gap. Gap is a numeric dimension (px) — no colour tokens are
 * involved, so styles are inline. The data attribute lets the host
 * stylesheet target this primitive if it ever needs to.
 */
export function Stack(props) {
    const { direction = 'column', gap = 8, style, children, ...rest } = props;
    return (_jsx("div", { "data-ui-stack": "", "data-direction": direction, style: {
            display: 'flex',
            flexDirection: direction,
            gap: `${gap}px`,
            ...style,
        }, ...rest, children: children }));
}
//# sourceMappingURL=Stack.js.map